import classNames from 'classnames';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { Session } from '../../../api/types/session';
import { Voucher } from '../../../api/types/voucher';
import { getTimezone } from '../../../selectors/hubSelector';
import { DATE_FORMAT_TYPE_15 } from '../../../util/constants';

export type VoucherListItemProps = {
  voucher: Voucher;
  originalSession?: Session;
};

export const VoucherListItem = ({ voucher, originalSession }: VoucherListItemProps) => {
  const { status, expiryDate, usedDate } = voucher;
  const timezone = useSelector(getTimezone);

  return (
    <div
      className={classNames('mb-5 flex flex-col gap-4 rounded-lg border-grey-3 p-5', {
        'bg-grey-1': status === 'Used',
        'bg-white': status !== 'Used',
        'border-2 border-dashed': status === 'Expired',
        'border shadow-md': status !== 'Expired',
      })}
    >
      <div className="flex flex-row justify-between gap-2">
        <h2 className="text-xl font-bold">60 minute session voucher</h2>
        <p
          className={classNames('flex items-center rounded-md px-2 py-1 text-xs font-bold uppercase', {
            'text-white': status === 'Active',
            'bg-green-4': status === 'Active',
            'bg-grey-2': status === 'Expired',
            'bg-slate-3': status === 'Used',
          })}
        >
          {status}
        </p>
      </div>
      <p>
        <b>Original session date: </b>
        {originalSession ? moment(originalSession.startTime).tz(timezone).format(DATE_FORMAT_TYPE_15) : 'N/A'}
      </p>
      {status === 'Active' && <p>Use this voucher by booking a make-up session</p>}
      <p>
        {status === 'Active' && (
          <>
            Valid until <b>{moment(expiryDate).tz(timezone).format(DATE_FORMAT_TYPE_15)}</b>
          </>
        )}
        {status === 'Expired' && <>Expired on {moment(expiryDate).tz(timezone).format(DATE_FORMAT_TYPE_15)}</>}
        {status === 'Used' && <>Used on {moment(usedDate).tz(timezone).format(DATE_FORMAT_TYPE_15)}</>}
      </p>
    </div>
  );
};
